import $store from '@/store/index'
import Tool from './utils.js'
const protocol = window.location.protocol
function loadSource (data) {
  window.serviceList = {
    userseviceUrl: `${protocol}//${data.userAuthUrl}`,
    mediaApiUrl: `${protocol}//${data.mediaApiUrl}`, // 用于media接口
    mediaServerUrl: `${protocol}//${data.mediaFrontUrl}`, // 用于media js
    blobUrl: `${protocol}//${data.blobUrl}`,
    userserviceApi: `${protocol}//${data.userAuthUrl}` // "cc-ms-dev.tvunetworks.com/userAuth"， userauth地址 （可按照服务后端配置自行绑定）
  }
}
// 加载language的js文件
const loadLanguageJs = () => {
  const jsUrl = `${protocol}//${$store.state.initConfig.languageUrl}/langConfig.js`
  document.write(`<script type="text/javascript" src=${jsUrl} ></script>`)
  // isCompleteLoad()
}
// const isCompleteLoad = () => {
//   if (typeof langConfig != 'undefined') {
//     // $store.state.common.hasInitLang = true
//   } else {
//     setTimeout(() => {
//       isCompleteLoad()
//     }, 100)
//   }
// }
// 加载mediaCommon
function loadMediaJs (initConfig, callback) {
  // 若当前js界面中已存在，则无需加载
  // if (
  //   document.querySelectorAll('#mediaCommon') &&
  //   document.querySelectorAll('#mediaCommon').length > 0 &&
  //   typeof callback == 'function'
  // ) {
  //   callback()
  // } else {
  loadSource(initConfig)
  const url = `https://${initConfig.mediaFrontUrl}/js/mediaCommon.js`
  // const url = 'https://summer92-81.tvunetworks.com/js/mediaCommon.js'
  // const url = 'https://sunny-dev8083.tvunetworks.com/js/mediaCommon.js'
  Tool.dynamicLoadJs(
    url,
    () => {
      if (typeof callback == 'function') {
        callback()
      }
    },
    'mediaCommon'
  )
  // }
}

// 加载mediaCommon
function loadSearchObjectJs (callback) {
  // 若当前js界面中已存在，则无需加载
  if (
    document.querySelectorAll('#searchObjectJs') &&
    document.querySelectorAll('#searchObjectJs').length > 0 &&
    typeof callback == 'function'
  ) {
    callback()
  } else {
    const url = `${window.location.protocol}//${$store.state.operateObject.searchUrl}/search/js/SourceObject.js`
    Tool.dynamicLoadJs(
      url,
      (data) => {
        if (typeof callback == 'function') {
          callback(data)
        }
      },
      'searchObjectJs'
    )
  }
}
export { loadSource, loadMediaJs, loadLanguageJs, loadSearchObjectJs }
